/* eslint-disable import/prefer-default-export */

import { i18nMark } from 'lingui-react';

const defaultFieldConfig = {
  maxLength: 50,
};

export const fieldsConfig = {
  poNumber: {
    ...defaultFieldConfig,
    label: i18nMark('PO Number (optional)'),
    placeholder: i18nMark('Enter PO number...'),
  },

  referenceNumber: {
    ...defaultFieldConfig,
    label: i18nMark('Reference Number (optional)'),
    placeholder: i18nMark('Enter reference number...'),
  },

  ticketNumber: {
    ...defaultFieldConfig,
    label: i18nMark('Ticket/DR Number (optional)'),
    placeholder: i18nMark('Enter ticket/DR number...'),
  },

  woNumber: {
    ...defaultFieldConfig,
    label: i18nMark('Work Order Number (optional)'),
    placeholder: i18nMark('Enter work order number...'),
  },

  invoiceNumber: {
    ...defaultFieldConfig,
    label: i18nMark('Invoice Number (optional)'),
    placeholder: i18nMark('Enter invoice number...'),
  },

  contractNumber: {
    ...defaultFieldConfig,
    label: i18nMark('Contract Number (optional)'),
    placeholder: i18nMark('Enter contract number...'),
  },

  releaseNumber: {
    ...defaultFieldConfig,
    label: i18nMark('Release Number (optional)'),
    placeholder: i18nMark('Enter release number...'),
  },

  amount: {
    ...defaultFieldConfig,
    label: i18nMark('Amount (optional)'),
    placeholder: i18nMark('Enter amount...'),
    textFieldPrefix: '$',
    pattern: /^[0-9,.]+$/,
  },

  comment: {
    ...defaultFieldConfig,
    label: i18nMark('Billing Comment (optional)'),
    placeholder: i18nMark('Enter Comment...'),
    maxLength: 300,
    multiline: true,
    showCharsCounter: true,
  },
};

export const ruleTypesLabels = {
  REQUIRED: i18nMark('Required:'),
  REQUIRED_BEFORE_ERS: i18nMark('Required Before ERS:'),
};

export const requiredFieldsLabels = {
  poNumber: i18nMark('PO Number'),
  contractNumber: i18nMark('Contract Number'),
  releaseNumber: i18nMark('Release Number'),
};



// WEBPACK FOOTER //
// ./src/compositions/CaseBillingPanel/constants.js